export const SURVEY_ROLES = ['GSR_NEXUS_SURVEYOR', 'GSR_NEXUS_SURVEY_ADMIN', 'GSR_PRODUCTION_DRAWER'];

export function hasAnyRole(roles: string[], anyOf: string[]): boolean {
  let found = false;
  anyOf.forEach((role) => {
    found = found || hasRole(roles, role);
  });

  return found;
}

export function hasRole(roles: string[], role: string): boolean {
  return roles && roles.length ? roles.indexOf(role) !== -1 : false;
}

export function hasRoleOrRedirect(roles: string[], role: string): boolean | string[] {
  let ret: boolean | string[];

  if (roles && roles.length) {
    ret = roles.indexOf(role) !== -1;
  } else {
    ret = ['/403'];
  }

  return ret;
}

export function hasAnyRoleOrRedirect(roles: string[], anyOf: string[]): boolean | string[] {
  let ret: boolean | string[] = false;

  if (roles && roles.length) {
    anyOf.forEach((role) => {
      ret = ret || hasRole(roles, role);
    });
  } else {
    ret = ['/403'];
  }

  return ret;
}
